import { FC } from 'react'

import { AssignmentLateOutlineRoundedIcon } from '@/components/icons'

const EmptyData: FC = () => {
  return (
    <div className="flex flex-col w-full justify-center items-center p-8 gap-4 border border-t-0 rounded-ee-md rounded-es-md border-grayscale-300">
      <AssignmentLateOutlineRoundedIcon className="fill-primary w-14 h-14" />
      <h4 className="prose-headline-h6 text-neutral-black">
        Tudo limpo por aqui
      </h4>
    </div>
  )
}

export default EmptyData
